import { inject, type Provider } from '@angular/core';

import {
	CHART_EDITOR_PALETTE_HOST,
	type ChartEditorPaletteHost,
} from '@framework/analytics/components/editors/jepto-chart-editor/services/chart-editor-palette-host.token';

import { JepPaletteMutationsService } from '../services/jep-palette-mutations.service';
import { JepPaletteQueriesService } from '../services/jep-palette-queries.service';

export function provideJeptoChartEditorPaletteHost(): Provider {
	return {
		provide: CHART_EDITOR_PALETTE_HOST,
		useFactory: (): ChartEditorPaletteHost => {
			const queries = inject(JepPaletteQueriesService);
			const mutations = inject(JepPaletteMutationsService);
			return {
				listPalettes: clientId => queries.listPalettes(clientId),
				createPalette: payload => mutations.createPalette(payload),
			};
		},
	};
}
